import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptySearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 152,
	height: 120,
	viewBox: "0 0 152 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			className: "bgCircle",
			cx: 76,
			cy: 52,
			r: 52,
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_2718_166124)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cloud",
					d: "M77.6 16C66.8273 16 57.2978 21.3233 51.4987 29.4829C49.605 29.0363 47.6301 28.8 45.6 28.8C31.4615 28.8 20 40.2615 20 54.4C20 68.5385 31.4615 80 45.6 80L109.6 80C121.971 80 132 69.9712 132 57.6C132 45.2288 121.971 35.2 109.6 35.2C108.721 35.2 107.854 35.2506 107.002 35.349C102.098 23.9677 90.7797 16 77.6 16Z",
					fill: "#9FA8DF"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 45.6,
					cy: 54.4,
					rx: 25.6,
					ry: 25.6,
					fill: "url(#paint0_linear_2718_166124)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77.6,
					cy: 48,
					r: 32,
					fill: "url(#paint1_linear_2718_166124)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 109.6,
					cy: 57.5999,
					rx: 22.4,
					ry: 22.4,
					fill: "url(#paint2_linear_2718_166124)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "dot",
			cx: 21,
			cy: 19,
			r: 5,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "dot",
			cx: 18,
			cy: 109,
			r: 7,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "dot",
			cx: 145,
			cy: 35,
			r: 7,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "dot",
			cx: 134,
			cy: 8,
			r: 4,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_b_2718_166124)",
			children: [/* @__PURE__ */ _jsx("rect", {
				className: "searchCircle",
				x: 52,
				y: 62,
				width: 48,
				height: 48,
				rx: 24,
				fill: "#33395B"
			}), /* @__PURE__ */ _jsx("path", {
				className: "search",
				d: "M85 95L80.65 90.65M83 85C83 89.4183 79.4183 93 75 93C70.5817 93 67 89.4183 67 85C67 80.5817 70.5817 77 75 77C79.4183 77 83 80.5817 83 85Z",
				stroke: "#ADB2D1",
				strokeWidth: 4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_2718_166124",
				x: 0,
				y: 16,
				width: 152,
				height: 104,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 4,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_2718_166124"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 8 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2718_166124"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 4,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_2718_166124"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_2718_166124",
						result: "effect2_dropShadow_2718_166124"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_2718_166124",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_b_2718_166124",
				x: 44,
				y: 54,
				width: 64,
				height: 64,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 4
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_2718_166124"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_2718_166124",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2718_166124",
				x1: 23.2,
				y1: 41.143,
				x2: 32.9143,
				y2: 48.0001,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .2 }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2718_166124",
				x1: 49.6,
				y1: 31.4286,
				x2: 61.7429,
				y2: 40.0001,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .2 }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2718_166124",
				x1: 90,
				y1: 46,
				x2: 98.5,
				y2: 52,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .2 }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgEmptySearch;
